import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API_URL = "https://nightingale-intelligence-core.onrender.com";

const api = axios.create({
  baseURL: API_URL,
});

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("hh_token");
    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      api.get("/api/auth/me")
        .then(r => setUser(r.data))
        .catch(() => { localStorage.removeItem("hh_token"); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/api/auth/login", { email, password });
    localStorage.setItem("hh_token", r.data.access_token);
    api.defaults.headers.common["Authorization"] = `Bearer ${r.data.access_token}`;
    const profile = await api.get("/api/auth/me");
    setUser(profile.data);
    return profile.data;
  };

  const register = async (email, password, full_name, company) => {
    const r = await api.post("/api/auth/register", { email, password, full_name, company });
    localStorage.setItem("hh_token", r.data.access_token);
    api.defaults.headers.common["Authorization"] = `Bearer ${r.data.access_token}`;
    const profile = await api.get("/api/auth/me");
    setUser(profile.data);
    return profile.data;
  };

  const logout = () => {
    localStorage.removeItem("hh_token");
    delete api.defaults.headers.common["Authorization"];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, api }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
// Exporting 'api' as 'API' for backward compatibility in other files
export { api as API };
